import React, { useEffect, useState } from "react";
import "./authWrapper.css"; // new css file for shared styles
import getUprateLogo from "../images/getUprateLogo-blank.png";

const AuthWrapper = ({children, leftContent, rightContent }) => {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    // Add initial animation classes
    const authLeft = document.querySelector('.auth-left');
    if (authLeft) {
      authLeft.classList.add('fade-in');
    }
    
    // Trigger animations with a slight delay
    setTimeout(() => {
      setIsAnimated(true);
    }, 100);

    return () => {
      if (authLeft) {
        authLeft.classList.remove('fade-in');
      }
    };
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-left">
        {leftContent ? leftContent : null}
        
        <div className="auth-form">
          {children}
        </div>
      </div>
      <div className="auth-right">
        {rightContent ? rightContent : 
          <>
            {/* Background orbs */}
            <div className="orb orbB1"></div>
            <div className="orb orbB2"></div>
            <div className="orb orbB3"></div>
    
            <div className="logo-container">
              <img src={getUprateLogo} alt="Uprate Logo" className="logo" />
              <h2 className="company-name">Insight Loop</h2>
            </div>
          </>}
      </div>
    </div>
  );
};

export default AuthWrapper;
